// extracted by extract-css-chunks-webpack-plugin
module.exports = {"copyListWrapper":"H-OOD","tooltip":"Db8J2","btnLoading":"nGEUz","loader":"fLtsU"};